//import apiClient from './authService.js'
import apiClient from '../../shared/auth/services'

export const satsueiMemoCategoryService = {
  // Get satsuei memo category list
  async getSatsueiMemoCategoryList() {
    try {
      const response = await apiClient.post('/getSatsueiMemoCategory', {
        isContainDeleted: true,
        isColumnDeleted: true
      })
      return response.data
    } catch (error) {
      console.error('Get satsuei memo category list error:', error)
      throw error
    }
  },

  // Get library satsuei memo category list
  async getLibSatsueiMemoCategoryList() {
    try {
      const response = await apiClient.post('/getLibSatsueiMemoCategory')
      return response.data
    } catch (error) {
      console.error('Get lib satsuei memo category list error:', error)
      throw error
    }
  },

  // Add new satsuei memo categories
  async addSatsueiMemoCategoryList(newCategoryList) {
    try {
      const data = {
        satsueiMemoCategoryList: newCategoryList.map(category => ({
          satsueiMemoCategoryId: category.satsueiMemoCategoryId,
          satsueiMemoCategoryName: category.satsueiMemoCategoryName,
          orderIndex: category.orderIndex
        }))
      }
      const response = await apiClient.post('/addSatsueiMemoCategory', data)
      return response.data
    } catch (error) {
      console.error('Add satsuei memo category list error:', error)
      throw error
    }
  },

  // Update existing satsuei memo categories
  async updateSatsueiMemoCategoryList(updatedCategoryList) {
    try {
      const data = {
        satsueiMemoCategoryList: updatedCategoryList.map(category => ({
          satsueiMemoCategoryId: category.satsueiMemoCategoryId,
          satsueiMemoCategoryName: category.satsueiMemoCategoryName,
          orderIndex: category.orderIndex,
          deleteFlg: category.deleteFlg
        }))
      }
      const response = await apiClient.post('/updateSatsueiMemoCategory', data)
      return response.data
    } catch (error) {
      console.error('Update satsuei memo category list error:', error)
      throw error
    }
  },

  // Remove satsuei memo categories (mark as deleted)
  async removeSatsueiMemoCategoryList(removedCategoryList) {
    try {
      const data = {
        satsueiMemoCategoryList: removedCategoryList.map(category => ({
          satsueiMemoCategoryId: category.satsueiMemoCategoryId
        }))
      }
      const response = await apiClient.post('/removeSatsueiMemoCategory', data)
      return response.data
    } catch (error) {
      console.error('Remove satsuei memo category list error:', error)
      throw error
    }
  },

  // Add new satsuei memo columns
  async addSatsueiMemoColumnList(newColumnList) {
    try {
      const data = {
        satsueiMemoColumnList: newColumnList.map(column => ({
          satsueiMemoCategoryId: column.satsueiMemoCategoryId,
          satsueiMemoColumnId: column.satsueiMemoColumnId,
          satsueiMemoColumnName: column.satsueiMemoColumnName,
          columnType: column.columnType,
          requiredFlg: column.requiredFlg || 0,
          initialValue: column.initialValue,
          orderIndex: column.orderIndex
        }))
      }
      const response = await apiClient.post('/addSatsueiMemoColumn', data)
      return response.data
    } catch (error) {
      console.error('Add satsuei memo column list error:', error)
      throw error
    }
  },

  // Update existing satsuei memo columns
  async updateSatsueiMemoColumnList(updatedColumnList) {
    try {
      const data = {
        satsueiMemoColumnList: updatedColumnList.map(column => ({
          satsueiMemoCategoryId: column.satsueiMemoCategoryId,
          satsueiMemoColumnId: column.satsueiMemoColumnId,
          satsueiMemoColumnName: column.satsueiMemoColumnName,
          columnType: column.columnType,
          requiredFlg: column.requiredFlg || 0,
          initialValue: column.initialValue,
          orderIndex: column.orderIndex,
          deleteFlg: column.deleteFlg
        }))
      }
      const response = await apiClient.post('/updateSatsueiMemoColumn', data)
      return response.data
    } catch (error) {
      console.error('Update satsuei memo column list error:', error)
      throw error
    }
  },

  // Remove satsuei memo columns (mark as deleted)
  async removeSatsueiMemoColumnList(removedColumnList) {
    try {
      const data = {
        satsueiMemoColumnList: removedColumnList.map(column => ({
          satsueiMemoCategoryId: column.satsueiMemoCategoryId,
          satsueiMemoColumnId: column.satsueiMemoColumnId
        }))
      }
      const response = await apiClient.post('/removeSatsueiMemoColumn', data)
      return response.data
    } catch (error) {
      console.error('Remove satsuei memo column list error:', error)
      throw error
    }
  },

  // Add new satsuei memo column values
  async addSatsueiMemoColumnValueList(newValueList) {
    try {
      const data = {
        satsueiMemoColumnValueList: newValueList.map(value => ({
          satsueiMemoCategoryId: value.satsueiMemoCategoryId,
          satsueiMemoColumnId: value.satsueiMemoColumnId,
          satsueiMemoColumnValueId: value.satsueiMemoColumnValueId,
          satsueiMemoColumnValueName: value.satsueiMemoColumnValueName,
          initialValueFlg: value.initialValueFlg || 0,
          orderIndex: value.orderIndex
        }))
      }
      const response = await apiClient.post('/addSatsueiMemoColumnValue', data)
      return response.data
    } catch (error) {
      console.error('Add satsuei memo column value list error:', error)
      throw error
    }
  },

  // Update existing satsuei memo column values
  async updateSatsueiMemoColumnValueList(updatedValueList) {
    try {
      const data = {
        satsueiMemoColumnValueList: updatedValueList.map(value => ({
          satsueiMemoCategoryId: value.satsueiMemoCategoryId,
          satsueiMemoColumnId: value.satsueiMemoColumnId,
          satsueiMemoColumnValueId: value.satsueiMemoColumnValueId,
          satsueiMemoColumnValueName: value.satsueiMemoColumnValueName,
          initialValueFlg: value.initialValueFlg || 0,
          orderIndex: value.orderIndex,
          deleteFlg: value.deleteFlg
        }))
      }
      const response = await apiClient.post('/updateSatsueiMemoColumnValue', data)
      return response.data
    } catch (error) {
      console.error('Update satsuei memo column value list error:', error)
      throw error
    }
  },

  // Remove satsuei memo column values (mark as deleted)
  async removeSatsueiMemoColumnValueList(removedValueList) {
    try {
      const data = {
        satsueiMemoColumnValueList: removedValueList.map(value => ({
          satsueiMemoCategoryId: value.satsueiMemoCategoryId,
          satsueiMemoColumnId: value.satsueiMemoColumnId,
          satsueiMemoColumnValueId: value.satsueiMemoColumnValueId
        }))
      }
      const response = await apiClient.post('/removeSatsueiMemoColumnValue', data)
      return response.data
    } catch (error) {
      console.error('Remove satsuei memo column value list error:', error)
      throw error
    }
  },

  // Register library satsuei memo
  async registLibSatsueiMemo(libSatsueiMemoCategoryList) {
    try {
      const response = await apiClient.post('/registLibSatsueiMemo', {
        libSatsueiMemoCategoryList
      })
      return response.data
    } catch (error) {
      console.error('Register lib satsuei memo error:', error)
      throw error
    }
  },

  // Create Z object
  async createZObject(satsueiMemoCategoryList) {
    try {
      const response = await apiClient.post('/createZObject', {
        satsueiMemoCategoryList
      })
      return response.data
    } catch (error) {
      console.error('Create Z object error:', error)
      throw error
    }
  }
}
